/* eslint-disable */
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';
import SideNavBar from '@icimscorp/mui-acs/build/components/SideNavBar';
import Dialog from '@material-ui/core/Dialog';
import Preferences from '../Preferences';
import { userActions } from 'redux/actions';
// eslint-disable-next-line id-match
import { outbound } from 'extActions';
import { routes as appRoutes } from '../AppRoutes';
import { sendMsgToExt } from 'util/messagePassing';
import { formatPhoneNumber } from 'util/helpers';
import PropTypes from 'prop-types';
import { track } from 'util/pendo';
import { useTranslation } from 'react-i18next';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { HELP_URL, HELP_CENTER_URL, pendoTypes } from 'appConstants';

const SideNav = ({ history }) => {
	const dispatch = useDispatch();
	const { t } = useTranslation();
	const { enableNewSupportLink } = useFlags();
	const { user, thread } = useSelector((state) => state);
	const [togglePreferences, setTogglePreferences] = React.useState(false);
	const { preferences, authenticated, inboxAccessList } = user;
	const { isSwitchOn } = preferences;
	const routes = ['Home', 'Candidates'];
	const { internalCustomerType } = useSelector((state) => state.user.customer);

	const handleSwitch = () => {
		dispatch(userActions.toggleSwitch());

		track(
			pendoTypes.highlightToggled,
			{
				// opposite of current status tracks the new state of highlight
				highlightStatus: !isSwitchOn
			},
			internalCustomerType
		);
		/**
		 * Send message to extension to stop phone number detection if switch is currently on and user decided to disable it,
		 * otherwise command extension to resume phone number detection
		 */
		// eslint-disable-next-line id-match
		const action = isSwitchOn ? outbound.STOP_HIGHLIGHT : outbound.RESUME_HIGHLIGHT;
		return sendMsgToExt({ action });
	};

	const appLocations = {
		home: 'home',
		team: 'teamInbox',
		user: 'inbox',
		candidates: 'candidates',
		candidate: 'candidates',
		thread: 'inbox'
	};
	const preferencesDialogOpen = () => setTogglePreferences(!togglePreferences);
	const preferencesDialogClose = () => setTogglePreferences(false);
	const getLocationFromHistory = history.location.pathname.split('/');
	const currentAppLocation =
		getLocationFromHistory[1] === 'inbox'
			? appLocations[getLocationFromHistory[2]]
			: appLocations[getLocationFromHistory[1]];

	const handleNavigation = (value) => {
		/* closing the preferences dialog while navigating to other routes */
		preferencesDialogClose();
		switch (value) {
			case 'home':
				history.push(appRoutes.HOME);
				break;
			case 'teamInbox':
				history.push({
					pathname: appRoutes.INBOX_TEAM,
					inboxType: 'team'
				});
				break;
			case 'inbox':
				history.push({
					pathname: appRoutes.INBOX_USER,
					inboxType: 'user'
				});
				break;
			case 'candidates':
				history.push(appRoutes.CANDIDATES);
				break;
			default:
				history.push(appRoutes.HOME);
				break;
		}
	};

	const handleSignOut = () => {
		preferencesDialogClose();
		dispatch(userActions.logout());
	};

	// eslint-disable-next-line react/no-multi-comp
	const renderOptions = () => {
		if (authenticated) {
			inboxAccessList.forEach(
				(item) => (routes[item.accountType.toLowerCase()] = item.accountName)
			);
			const formattedPhoneNumberAndCountryCode = formatPhoneNumber(user.smsPhoneNumber);
			const inboxes = inboxAccessList.map((inbox) => inbox.accountType.toLowerCase());
			const countryCode = formattedPhoneNumberAndCountryCode.ISO3166CountryCode.toLowerCase();

			let helpText = t('help', 'Help');
			let helpUrl = HELP_URL;
			if (enableNewSupportLink) {
				helpText = t('help_center', 'Help Center');
				helpUrl = HELP_CENTER_URL;
			}

			return (
				<div>
					<SideNavBar
						data-testid="sideNavBar"
						inboxMessageCount={thread.user.totalUnreadMessageCount}
						teamInboxMessageCount={thread.team.totalUnreadMessageCount}
						handleOnClick={handleNavigation}
						enableToggle={isSwitchOn}
						handleToggleOnClick={handleSwitch}
						handleSignOutClick={handleSignOut}
						isLogin={user.authenticated}
						candidateName={user.userName}
						contactNumber={formattedPhoneNumberAndCountryCode.formattedPhoneNumber}
						countryCode={countryCode}
						handleWebExtensionOnClick={preferencesDialogOpen}
						selectedListItem={currentAppLocation ? currentAppLocation : 'home'}
						inboxAccessList={inboxes}
						helpCenterUrl={helpUrl}
						helpText={helpText}
					/>
				</div>
			);
		}
		return (
			<div>
				<SideNavBar
					data-testid="sideNavBar"
					enableToggle={isSwitchOn}
					handleToggleOnClick={handleSwitch}
				/>
			</div>
		);
	};
	return (
		<>
			<div className="trx-sidebar-nav">
				<ul className="trx-sidebar-list">{renderOptions()}</ul>
			</div>
			<Dialog
				open={togglePreferences}
				onClose={preferencesDialogClose}
				fullScreen
				style={{ width: 'calc(100% - 72px)', zIndex: 200 }}
			>
				<Preferences handleWebExtensionSettingsClose={preferencesDialogClose} />
			</Dialog>
		</>
	);
};

SideNav.propTypes = {
	history: PropTypes.object
};

export default withRouter(SideNav);
